import React, { Component } from 'react'

export default class OWCP extends Component {
    render() {
        return (
            <div>
                <h5>OWCP</h5>
            </div>
        )
    }
}
